import React from 'react'
import {BucketLinkButton} from './BucketLinkButton'
import {ContentTitle} from '../../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentBlock} from '../../../Molecules/BaseContentBlocks/ContentBlock'
import {PageUrlInfo} from '../../../../Models/Types'
import {MBContentBodyItemTypography} from '../../../Atoms/Typographies'

type Props = {
  title: string
  pageUrlInfoList: PageUrlInfo[]
  noSignboardListMessage: string
  testId?: string
}

export const FanClubLinkListContentBlock: React.VFC<Props> = (props) => {
  const content = (): JSX.Element => {
    if (props.pageUrlInfoList.length === 0) {
      return <>
        <ContentTitle>{props.title}</ContentTitle>
        <MBContentBodyItemTypography>
          {props.noSignboardListMessage}
        </MBContentBodyItemTypography>
      </>
    }

    return <>
      <ContentTitle noMarginBottom={true}>{props.title}</ContentTitle>
      <div className="useful-info">
        {
          props.pageUrlInfoList?.map((pageUrlInfo, idx) =>
            <div key={idx}>
              <BucketLinkButton pageUrlInfo={pageUrlInfo}/>
            </div>
          )
        }
      </div>
    </>
  }

  return <ContentBlock data-testid={props.testId}>
    {content()}
  </ContentBlock>
}
